

import React, { Fragment as F, useContext, useEffect, useLayoutEffect, useState } from 'react'

import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import _Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import _TabPanel from '@mui/lab/TabPanel'

import Select from 'react-select'
import Switch from '@mui/material/Switch'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBuildingColumns,
  faChevronLeft, faChevronRight, faCircleQuestion, faCreditCard,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import {
  C,
  logg,
} from "$shared"

library.add(
  faBuildingColumns,
  faChevronLeft, faChevronRight, faCircleQuestion, faCreditCard,
  faQuestion,
);




/*
 * operator
**/
const operator = (props) => {
  if (props.DEBUG) { logg(props, 'operator()') }
  const {
    clause, setClause,
    setCriterionModalOpen,
    query,  setQuery,
  } = props

  let op = null
  switch (clause.operator) {
    case undefined:
    case null:
    case '':
      throw('zz3 - clause.operator cannot be empty')

    case C.op.bool:
      op = <Switch inputProps={{ 'aria-label': clause.label }} />
      break

    case C.op.toggle:
      op = <Switch color="red"
        checked={query[clause.key].value === clause.options[1]}
        onChange={(ev) => setQuery({...query,
          [clause.key]: {...query[clause.key], value: ev.target.checked ? clause.options[1] : clause.options[0] },
        }) }
        inputProps={{ 'aria-label': clause.label }}
      />
      break

    case C.op.match_i:
      op = <F>
        <input type="text"
          name={clause.key}
          onChange={(ev) => setQuery({...query,
            [clause.key]: {...query[clause.key], value: ev.target.value },
          }) }
          value={query[clause.key].value}
        />
      </F>
      break

    case C.op.multiselect_checkboxes:
      op = <div className="d-inline-block">
        { clause.options.map((opt, idx) => <div key={idx}>
          {/* { opt.value } */}
          <FormControlLabel
            control={<Checkbox
              checked={ query[clause.key].value[opt.value]||false }
              inputProps={{ 'aria-label': opt.label }}
              onChange={(ev) => {
                const q = {...query}
                if (query[clause.key].value[opt.value]) {
                  delete q[clause.key].value[opt.value]
                } else {
                  q[clause.key].value[opt.value] = true
                }
                setQuery(q)
              } }
            />}
            label={ opt.label }
          ></FormControlLabel>
        </div>) }
      </div>
      break

    case C.op.multiselect_select2:
      op = <F>
        {/* <InputLabel className='select2-label' >{clause.label}</InputLabel> */}
        <Select
          className='select2'
          classNamePrefix="rs2"
          isMulti
          name={clause.label}
          options={clause.options}
          value={clause.options.filter(e => query[clause.key].value.indexOf(e.value) != -1)}
          onChange={(vs) => { // vs=values
            const q = {...query}
            q[clause.key].value = vs.map(v => v.value)
            setQuery(q)
          }}
          styles={C.select2Styles}
        />
      </F>
      break

    case C.op.between:
      op = <F>
        &nbsp; Min &nbsp;
        <input type='number' step='1'
          onChange={(ev) => {
            // logg(ev, 'ev')
            const q = {...query}
            q[clause.key].value = [ ev.target.value, query[clause.key].value[1] ]
            setQuery(q)
          } }
          value={query[clause.key].value[0]} />
        &nbsp; Max &nbsp;
        <input type='number' step='1'
          onChange={(ev) => {
            // logg(ev, 'ev')
            const q = {...query}
            q[clause.key].value = [ query[clause.key].value[0], ev.target.value ]
            setQuery(q)
          } }
          value={query[clause.key].value[1]} />
      </F>
      break

    case C.op.search_range:
      op = <F>
        <div className='d-flex'>
          {/* Friendly Name */}
          <div className='descr flex-grow'>{ query[clause.key].value.period && <F>{query[clause.key].ubpr_label} [{query[clause.key].period_label}]</F> || <F>&nbsp;</F> }</div>
          <div className='Btn' onClick={() => setCriterionModalOpen(clause.key)} >Select</div>
          <div className='Btn ml-3' onClick={() => {
            const q = {...query}
            q[clause.key] = { value: {} }
            setQuery(q)
          } } >Clear</div>
        </div>
        <div className='d-flex'>
          <select
            className="op-1"
            value={query[clause.key].value.op_1}
            onChange={(ev) => {
              const q = {...query}
              q[clause.key].value.op_1 = ev.target.value
              setQuery(q)
            }}
          >
            <option value='min' >min</option>
            <option value='eq'>=</option>
            <option value='neq'>not =</option>
            <option value='lt'>&lt;</option>
            <option value='lte'>&lt;=</option>
            <option value='gt'>></option>
            <option value='gte'>>=</option>
            <option value='max'>max</option>
          </select>
          <input className="val-1" type='text' placeholder="(000's)"
            value={query[clause.key].value.val_1}
            onChange={(ev) => {
              const q = {...query}
              q[clause.key].value.val_1 = ev.target.value
              setQuery(q)
            }}
          />
          <select
            className="op-2"
            value={query[clause.key].value.op_2}
            onChange={(ev) => {
              const q = {...query}
              q[clause.key].value.op_2 = ev.target.value
              setQuery(q)
            }}
          >
            <option value='min'>min</option>
            <option value='eq'>=</option>
            <option value='neq'>not =</option>
            <option value='lt'>&lt;</option>
            <option value='lte'>&lt;=</option>
            <option value='gt'>></option>
            <option value='gte'>>=</option>
            <option value='max' >max</option>
          </select>
          <input className="val-2" type='text' placeholder="(000's)"
            onChange={(ev) => {
              const q = {...query}
              q[clause.key].value.val_2 = ev.target.value
              setQuery(q)
            }}
            value={query[clause.key].value.val_2}
          />
        </div>
      </F>
      break

    default:
      throw('zz4 - this should not happen.')
  }

  const options =[]
  for (let [k, v] of Object.entries(C.op)) {
    options.push({ label: k, vale: k })
  }
  return <div className='Operator' >
    { clause.showOperator && <Select className='select2'
      name='operator'
      options={options}
      value={{ label: clause.operator, value: clause.value }}
      style={C.select2Styles}
    /> }
    { op }
  </div>
}


/**
 * Criterion
**/
const Criterion = (props) => {
  // logg(props, `criterion ${props.key}`)
  const {
    clause: _, setClause,
    setCriterionModalOpen,
    criteriaOpts,
    query, setQuery,
  } = props

  const clause = query.clauses[props.key]
  // logg(clause, 'clause')

  const removeClause = () => {
    delete query.clauses[props.key]
    setQuery({ ...query })
  }

  return <F>
    <div className='d-flex align-items-baseline mb-3' style={{ lineHeight: '1rem', textAlign: 'baseline' }} >
      <div className='Btn mr-2' onClick={removeClause} >X</div>
      <div className='m-2'>Dimension</div>
      <OverlayTrigger placement="bottom"
        overlay={<Tooltip >A dimension is a ubpr code</Tooltip>}
      >
        <FontAwesomeIcon
          icon={`fa-solid fa-circle-question`}
          style={{ color: '#999' }}
        />
      </OverlayTrigger>
      &nbsp;
      <Select
        className='select2 flex-grow'
        name={ 'type' }
        options={ criteriaOpts }
        value={ criteriaOpts.filter(c => c.value === clause.column_name)[0] }
        onChange={(ev) => {
          clause.column_name = ev.value
          setQuery({...query, clauses: { ...query.clauses, [props.key]: clause } })
        } }
        styles={C.select2Styles}
      />
    </div>
    { clause.column_name && <div className='d-flex mb-4 '>
      { operator({ clause, setClause, query, setQuery, key: props.key }) }
      For period
      <Select
        className='select2 flex-grow'
        // isMulti
        name={ 'periods' }
        options={[ {label: '@TODO', value: '@TODO' } ]}
        value={{ label: clause.period, value: clause.period }}
        onChange={(ev) => setClause(props.key, {...clause, period: ev.value }) }
        styles={C.select2Styles}
      />
    </div> }
  </F>
}

export default Criterion
export {
  Criterion,
  operator,
}




